import React, { FC, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import { ISideBarItem } from '../types';
import useStyles from '../styles';
import { tt } from '@i18n/tt';

interface IProps extends ISideBarItem {}

const SideBarItem: FC<IProps> = ({ icon, title, path }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const classes = useStyles();

  const handleRedirect = useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate],
  );

  const isSelected = useMemo(() => pathname.split('/').includes(path.replace('/', '')), [path, pathname]);

  return (
    <div
      className={
        !isSelected
          ? classes.sideBarItem
          : classNames(classes.sideBarItem, classes.sideBarItemActive)
      }
      onClick={() => {
        handleRedirect(path);
      }}
    >
      {icon}
      {tt(title as 'sideBar.home')}
    </div>
  );
};

export default SideBarItem;
